module.exports = __webpack_public_path__ + "img/Lot7.63cadcef.jpg";